import * as React from "react";
import classnames from "classnames";
/* empty css         */
const Tab = ({ label, onClick, isActive, className, variant = "primary", ...rest }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    ...rest,
    onClick,
    className: classnames(`tab tab--${variant}`, className, {
      _is_active: isActive
    }),
    "aria-pressed": isActive
  },
  label
);
Tab.displayName = "Tab";
export {
  Tab as default
};
//# sourceMappingURL=Tab.js.map
